export const suspendUser = async (userID, setSuspendUserStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/suspendUser.php?adminRequired=true&userID=" + userID,
      {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setSuspendUserStatusMessage(result.message);
    } else {
      setSuspendUserStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setSuspendUserStatusMessage(error.message);
  }
};